import { render, staticRenderFns } from "./solenoidDialog.vue?vue&type=template&id=4c60b740&"
import script from "./solenoidDialog.vue?vue&type=script&lang=ts&"
export * from "./solenoidDialog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports